
import Vue from "vue";
import { FTextField, FRadioGroup, FRadioGroupField, FTooltip, FLabel } from "@fkui/vue";
import { mapFields } from "vuex-map-fields";
import AnstalldFieldGroup from "@/components/Observationer/AnstalldFieldGroup.vue";
import AnonymMessageBox from "@/components/Kontaktuppgifter/AnonymMessageBox.vue";
import FileUploader from "@/components/Observationer/FileUploader.vue";
import SammanboendeFieldGroup from "@/components/Observationer/SammanboendeFieldGroup.vue";
import UtomlandsFieldGroup from "@/components/Observationer/UtomlandsFieldGroup.vue";
import FelaktigAssistansFieldGroup from "@/components/Observationer/FelaktigAssistansFieldGroup.vue";
import AnnatPrivatpersonFieldGroup from "@/components/Observationer/AnnatPrivatpersonFieldGroup.vue";
import StatligtTandvardsstodFieldGroup from "@/components/Observationer/StatligtTandvardsstodFieldGroup.vue";
import AnnatForetagFieldGroup from "@/components/Observationer/AnnatForetagFieldGroup.vue";
import MedvetetFelForetagFieldGroup from "@/components/Observationer/MedvetetFelForetagFieldGroup.vue";
import MedvetetFelPrivatpersonFieldGroup from "@/components/Observationer/MedvetetFelPrivatpersonFieldGroup.vue";
import { Anonym, DinMisstanke, VilkenSituation, VilkenRoll, Underrattelseskyldighet } from "@/store/types";
import { showComponentMixin } from "@/utils/mixins";
import { isFelaktigErsattningEnabled } from "@/utils";
import FkRichtext from "fk-vue-richtext";

export default Vue.extend({
    name: "FkObservationer",
    components: {
        AnonymMessageBox,
        AnstalldFieldGroup,
        FRadioGroup,
        FRadioGroupField,
        FileUploader,
        FkRichtext,
        FTextField,
        FTooltip,
        FLabel,
        SammanboendeFieldGroup,
        UtomlandsFieldGroup,
        FelaktigAssistansFieldGroup,
        AnnatPrivatpersonFieldGroup,
        StatligtTandvardsstodFieldGroup,
        AnnatForetagFieldGroup,
        MedvetetFelForetagFieldGroup,
        MedvetetFelPrivatpersonFieldGroup,
    },
    mixins: [showComponentMixin],
    data: () => ({
        Anonym,
        DinMisstanke,
        VilkenSituation,
        VilkenRoll,
        Underrattelseskyldighet,
    }),
    computed: {
        ...mapFields([
            "kontaktuppgifter.villDuVaraAnonym",
            "observationer.situation",
            "observationer.typAvErsattning",
            "observationer.underrattelseskyldighet",
            "observationer.bilagor",
            "forsteg.misstanke",
            "forsteg.vilkenroll",
        ]),
    },
    methods: {
        shouldShowFelaktigErsattning(misstanke: DinMisstanke, situation: VilkenSituation): boolean {
            return isFelaktigErsattningEnabled(misstanke, situation);
        },
    },
});
